
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/second-opinion-thoracic-surgeon-india",
      function () {
        return require("private-next-pages/second-opinion-thoracic-surgeon-india.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/second-opinion-thoracic-surgeon-india"])
      });
    }
  